import React from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import './detalle-itinerary.css';

const DetalleItinerario = ({ itinerary }) => {
  const itineraryByOrder = itinerary.sort((a, b) => a.order - b.order);
  const mobile = isClient ? window.innerWidth <= 768 : false;

  return (
    <div className='itinerary-container'>
      <div className='line-container'>
        <span className='linea' />
      </div>
      {
        itineraryByOrder.map((item) => (
          <div key={item.id} className='item-row'>
            <div className={`itinerary-img-place ${mobile ? 'hidden' : ''}`}>
              <div className='itinerary-img-container'>
                {/* <img
                  className="itinerary-img"
                  src="https://i.picsum.photos/id/608/600/400.jpg"
                  alt={item.title}
                /> */}
              </div>
            </div>
            <div className='itinerary-text-place'>
              <div className='circulo color-dinamico-fondo bg-mbr-color-primario' />
              <div className='itinerary-text-cointaner'>
                <h4 className='text-title'>{item.title}</h4>
                <p className='text-description text-sm text-gray-700'>{item.description}</p>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default DetalleItinerario;

/*
  Itinerary item :

    id: 68
    packageId: 94
    title: "ultimo ultimo no plata bara bara"
    imageUrl: ""
    description: ""
    order: 5
*/
